// Centralized data for the POG Spirits site

export const BRAND = {
  name: "POG Spirits",
  tagline: "Icons evolve. So we did.",
  partner: "In partnership with Meadow Gold · Distributed by Reyes / Island Distributing",
};

export const NAV_LINKS = [
  { id: "story", label: "Story" },
  { id: "products", label: "Products" },
  { id: "cocktails", label: "Cocktails" },
  { id: "press", label: "Press" },
  { id: "faq", label: "FAQ" },
];

export const PRODUCTS = [
  {
    id: "vodka",
    name: "POG Vodka",
    subtitle: "Island Punch with Natural Flavor",
    size: "750 ml",
    abv: "35% ALC/VOL · 70 Proof",
    image: "/products/pog-vodka.jpg",
    alt: "POG Vodka 750ml bottle — 35% ABV Passion Orange Guava vodka, in partnership with Meadow Gold, Hawai‘i",
    blurb:
      "Born from Hawai‘i's most beloved juice blend, POG Vodka delivers a bright, tropical-inspired profile with a crisp vodka finish. A vibrant twist on paradise — bottled for beach days, backyard nights, and every moment in between.",
    notes: [
      { k: "Aroma", v: "Passion fruit blossom, ripe orange peel, soft guava" },
      { k: "Palate", v: "Tropical sunlight, clean grain, a whisper of sea salt" },
      { k: "Finish", v: "Crisp, dry, a long warm sunset" },
    ],
    badge: "Flagship",
  },
  {
    id: "rtd",
    name: "POG Spike Island Punch",
    subtitle: "Sparkling Flavored Beverage with Real Fruit",
    size: "11.5 fl oz · 340 ml",
    abv: "6% ALC/VOL",
    image: "/products/pog-can.jpg",
    alt: "POG Spiked Island Punch RTD can — 6% ABV Hawaiian sparkling Passion Orange Guava punch",
    blurb:
      "Inspired by Hawai‘i's iconic POG flavor, POG Island Punch brings together the bright, tropical taste of passion fruit, orange, and guava in a crisp, refreshing beverage — a clean, balanced finish for every adventure.",
    notes: [
      { k: "Build", v: "Sparkling water, alcohol from fermented organic sugar" },
      { k: "Fruit", v: "Real passion fruit juice, guava purée, orange juice" },
      { k: "Profile", v: "Made with real fruit & organic flavors · 160 cal" },
    ],
    badge: "Ready to Drink",
  },
];

export const ROADMAP = [
  { name: "POG 2.0", note: "Pineapple", status: "In Development" },
  { name: "BOG", note: "Berry Orange Guava", status: "2026" },
  { name: "LOG", note: "Lilikoi Orange Guava", status: "2026" },
  { name: "Strawberry Guava", note: "Limited Release", status: "2026" },
  { name: "Lemon Iced Tea", note: "Hard Tea", status: "2027" },
  { name: "Guava Nectar", note: "Nectar Punch", status: "2027" },
];

export const COCKTAILS = [
  {
    id: "sunset",
    name: "The Kailua Sunset",
    glass: "Rocks · Large Cube",
    image: "/products/pog-can.jpg",
    ingredients: [
      "2 oz POG Vodka",
      "¾ oz fresh lime",
      "½ oz orgeat",
      "Soda to top",
      "Burnt orange peel",
    ],
    method:
      "Build over a large cube, stir gently, top with soda. Express orange peel over the glass and drop it in. Serve at golden hour.",
  },
  {
    id: "lei",
    name: "Lei Day Spritz",
    glass: "Wine Glass · Crushed Ice",
    image: "/products/pog-vodka.jpg",
    ingredients: [
      "1½ oz POG Vodka",
      "3 oz dry sparkling wine",
      "¾ oz passion fruit cordial",
      "Splash of guava nectar",
      "Edible orchid",
    ],
    method:
      "Build over crushed ice in a chilled wine glass. Stir once. Garnish with an edible orchid and a passion fruit half.",
  },
  {
    id: "punch",
    name: "Big Island Punch",
    glass: "Tiki Mug · Pebble Ice",
    image: "https://images.unsplash.com/photo-1502009285422-74e42ac2fd68",
    ingredients: [
      "1 can POG Spike Island Punch",
      "1 oz POG Vodka",
      "½ oz fresh lime",
      "3 dashes Angostura",
      "Mint bouquet",
    ],
    method:
      "Pour vodka, lime, and bitters into a tiki mug filled with pebble ice. Top with chilled POG RTD. Stir once and garnish with a mint bouquet.",
  },
];

export const PARTNERSHIP_BEATS = [
  { year: "1897", title: "Meadow Gold begins", body: "Founded in Hawai‘i; becomes the islands' most trusted dairy and beverage house." },
  { year: "1971", title: "POG is born", body: "A creamery worker blends Passion fruit, Orange, and Guava — and a cultural icon is created." },
  { year: "2026", title: "The Partnership & Launch", body: "POG Spirits — an independent spirits brand created in partnership with Meadow Gold — brings the iconic 1971 flavor into the bottle: POG Vodka 750ml Glass, 35% alc by volume, and POG Spiked Island Punch Ready-to-Drink, 6% alc by volume. Distributed across Hawai‘i by Reyes and Island Distributing." },
];

export const PRESS_LOGOS = [
  "Honolulu Magazine",
  "Beverage Industry",
  "The Spirits Business",
  "Aloha Magazine",
  "Imbibe",
  "Pacific Business News",
];

export const DISTRIBUTION = [
  { region: "O‘ahu", note: "Foodland, Whole Foods, Times — and select bars in Waikīkī" },
  { region: "Maui", note: "Safeway, Tamura's, Mahi Pono restaurant partners" },
  { region: "Big Island", note: "KTA Super Stores, Kona Wine Market" },
  { region: "Kaua‘i", note: "Big Save, Foodland, Tahiti Nui" },
  { region: "West Coast (Q3 2026)", note: "California, Nevada — DTC pilots" },
];

export const GOV_WARNING =
  "GOVERNMENT WARNING: (1) According to the Surgeon General, women should not drink alcoholic beverages during pregnancy because of the risk of birth defects. (2) Consumption of alcoholic beverages impairs your ability to drive a car or operate machinery, and may cause health problems.";
